import { createStore, applyMiddleware } from "redux";
import rootReducer from "../reducers";
import thunkMiddleware from "redux-thunk";

const debugware = [];
/**if (process.env.NODE_ENV !== 'production') {
    const createLogger = require('redux-logger');

    debugware.push(createLogger({
        collapsed: true,
    }));
}**/

export default function configureStore(initialState) {
    const store = createStore(rootReducer, initialState, applyMiddleware(thunkMiddleware, ...debugware));

    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('../reducers', () => {
            const nextRootReducer = require('../reducers/index').default;

            store.replaceReducer(nextRootReducer);
        });
    }

    return store
};



// WEBPACK FOOTER //
// ./src/store/configureStore.js